define('modules/common/Report',['jquery', 'JSTemplate', 'UI', 'DataList', 'Toastr', 'Validation','History', 'Config'], function($, template, UI, DataList, Toastr, Validation, History, Config) {

    "use strict";


    var langs = Config.get('lang'),
        REASONS = {

    },
    reportFormValidationRules = {
        reasonId: {
            presence: {
                message: '^' + langs.err_report
            },

        }
    };

    return function() {

        var o,
            defaults = {
                url: '/ajax/report/reason',
                containerId: 'container',
                template: 'tplReport',
                parentTemplate: 'tplReportContainer',
                parentContainerId: 'reportParentContainer'
            },
            action = {},
            $elContainer,
            onFetchComplete = function(data, params) {
                REASONS[params.apiData.type] = data.response;
            },

            // Function that generates the html and appends to the DOM
            _renderReport = function(type, apiData) {
                var html = template(o.parentTemplate, {
                        options: o,
                        action: action,
                        type: type,
                        apiData: apiData,
                        langs: langs
                    }),
                    dataList = new DataList();

                UI.$b.append(html);
                History.pushState({
                    url: window.location.pathname + '#report',
                    popupId: 'reportParentContainer'
                });

                $elContainer = $("#" + o.parentContainerId);

                if(REASONS.hasOwnProperty(type)) {
                    dataList.init({
                        containerId: o.containerId,
                        template: 'tplReport',
                        useApi: false,
                        data: REASONS[type],
                        multiselect: false,
                        selectable: true,
                        apiData: {
                            type: type
                        }
                    });
                } else {
                    dataList.init({
                        containerId: o.containerId,
                        template: 'tplReport',
                        useApi: true,
                        useApiAsData: false,
                        api: o.url,
                        multiselect: false,
                        selectable: true,
                        apiData: {
                            type: type
                        },
                        onfetchCallback: onFetchComplete
                    });
                }  

                UI.noscroll();
            },

            _bindEvents = function() {
                // Event triggered on form submit
                $('#reportForm').on('submit', function(ev) {
                    ev.preventDefault();

                    var validation = new Validation({
                        form: $(this),
                        allConstraints: reportFormValidationRules
                    });

                    if(validation.isValid() !== true) {
                        return;
                    }

                    $.ajax({
                        url: '/ajax/report',
                        data: $(this).serialize(),
                        type: 'POST',
                        success: function(result) {
                            var toastr;

                            if (result.status) {
                                $elContainer.fadeOut('500ms', function() {
                                    $elContainer.remove();
                                });

                                toastr = new Toastr({
                                    'message': result.message
                                });

                                UI.noscroll(false);

                            } else {
                                toastr = new Toastr({
                                    'message': result.message,
                                    'class' : 'toastr-error',
                                    'icon': 'ion-alert'
                                });
                            }
                            History.popState();
                        }
                    });

                });
            },

            init = function(options, type, actionItem, apiData) {
                o = $.extend(defaults, options);

                action = actionItem;

                _renderReport(type, apiData);

                _bindEvents();

            };

        return {
            init: init
        };
    };
});
